import React from 'react';
import './BookingPage.css';
import './App.css';

const ConsultationSuccess = () => {
  return (
    <div className="App">
      <div className="banner">
        <h1>Consultation Requested</h1>
      </div>
      <div style={{display: 'flex', justifyContent: 'center'}}>
        <div className="booking-form" style={{maxWidth: 900}}>
          <div>
            <p style={{marginBottom: '0.75rem', textAlign: 'center', fontSize: '1.25rem', fontWeight: 700}}>
              Your consultation request has been saved.
            </p>
            <p style={{textAlign: 'center', lineHeight: 1.5}}>
              Thank you. Your selected dates and entered details are on file, so payment can be completed more easily after the consultation.
            </p>
            <div style={{display: 'flex', justifyContent: 'center', marginTop: '1.25rem'}}>
              <button
                onClick={() => { window.location.href = '/'; }}
                style={{
                  background: '#ffb3c6',
                  border: 'none',
                  padding: '0.5rem 1rem',
                  borderRadius: 6,
                  cursor: 'pointer',
                  fontWeight: 600,
                }}
              >
                Back to main page
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsultationSuccess;
